import React from 'react';
import "../../CSS/Shop/marcacaoDePAgina.css";

const MarcacaoDePagina = () => {
  return (
    <div>

      <h3 className='tituloShop'>Home / Products</h3>
    </div>
  );
};

export default MarcacaoDePagina;